import { UI_LIST_BULK_MAX_ITEMS } from "../api/productReportUiListBulk";
import type { ProductReportUiListBulkItem } from "../api/productReportUiListBulk";
import { postProductReportsUiListBulk } from "../api/productReportUiListBulk";

/** Target ``ProductReports.ui_list`` for each misconduct compare row (legacy-only backfill). */
export const MISCONDUCT_COMPARE_UI_LIST_BY_ROW_ID: Record<string, string> = {
  in_process_queue: "RUN",
  in_progress: "RUN",
  pending_review: "REVIEW",
  reviewed: "COMPLETE",
  internal_qa: "IQA",
  client_qa: "CQA",
};

/** Target ``ProductReports.ui_list`` for each 360 compare row (legacy-only backfill). */
export const THREE_SIXTY_COMPARE_UI_LIST_BY_ROW_ID: Record<string, string> = {
  queuing: "QUEUE",
  web_search: "WEB",
  investigating: "RUN",
  qa: "360QA",
  finished: "COMPLETE",
};

export function chunkArray<T>(items: T[], size: number): T[][] {
  const chunks: T[][] = [];
  for (let i = 0; i < items.length; i += size) {
    chunks.push(items.slice(i, i + size));
  }
  return chunks;
}

export function buildUiListBulkItems(
  reportUuids: string[],
  uiList: string
): ProductReportUiListBulkItem[] {
  return reportUuids.map((external_id) => ({ external_id, ui_list: uiList }));
}

export async function syncOnlyInLegacyTab(
  requestApi: { post: (url: string, body: unknown) => Promise<{ data: unknown }> },
  reportType: "MISCONDUCT" | "360",
  reportUuids: string[],
  uiList: string
): Promise<{ updated: number; skipped: number; errors: number }> {
  const items = buildUiListBulkItems(reportUuids, uiList);
  let updated = 0;
  let skipped = 0;
  let errors = 0;
  for (const chunk of chunkArray(items, UI_LIST_BULK_MAX_ITEMS)) {
    const result = await postProductReportsUiListBulk(
      requestApi,
      reportType,
      chunk
    );
    updated += result.updated_count;
    skipped += result.skipped_count;
    errors += result.errors.length;
  }
  return { updated, skipped, errors };
}
